import { MESSAGE_VOTE } from "../apiConstant";
import BaseApi from "../baseApi";

class MessageVoteApi extends BaseApi {
  createVoteMessage(params) {
    return this.post(`${MESSAGE_VOTE}/create-vote`, params);
  }

  updateVoteMessage(params) {
    return this.post(`${MESSAGE_VOTE}/update-vote`, params);
  }
}

export default MessageVoteApi;
